import '.bx{position:relative;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.g6{min-height:200px;}.ssr-plugin'
import '.i{display:flex;}.ssr-plugin'
import '.j{flex-direction:column;}.ssr-plugin'
import '.o{justify-content:center;}.ssr-plugin'
import '.cf{align-items:flex-start;}.ssr-plugin'
import '.v{padding:2rem;}.ssr-plugin'
import '.co{background:var(--shades-white);}.ssr-plugin'
import '.h{overflow:hidden;}.ssr-plugin'
import '.d{position:absolute;}.ssr-plugin'
import '.ie{top:50%;}.ssr-plugin'
import '.if{right:1rem;}.ssr-plugin'
import '.ig{transform:translateY(-50%);}.ssr-plugin'
import '.ih{width:120px;}.ssr-plugin'
import '.ii{height:120px;}.ssr-plugin'
import '.ij{z-index:0;}.ssr-plugin'
import '.k{align-items:center;}.ssr-plugin'
import '.hn{z-index:1;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.ik{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bx a2 g6 i j o cf v co h"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="d ie if ig ih ii ij i k o"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bx hn i j cf aj ik"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
